import orderBy from "lodash/orderBy";

export const NetworkConstants = {
    INVITE_SOMEONE: 'Invite Someone',
    SUCCESSFULLY_RESIGNED: 'Successfully Resigned from the ',
    ERROR_WHILE_RESIGNING: 'Error while Resigning from the ',
    ERROR_WHILE_INVITING: 'One or more members you selected, do not meet the eligibility criteria.',
    SUCCESSFULLY_INVITED: 'Invitation has been sent',
    EMAIL_OPTIONS: ['Instantly', 'Weekly Digest', 'Daily Digest', 'Never'],
    WHEN_ANYONE_POST: 'When Anyone Post',
    YOU_ARE_NOT_ELIGIBLE_TO_JOIN_THIS_NETWORK: `You're not eligible to join this network`,
    PASTE_EMAIL_ADDRESS: 'PASTE EMAIL ADDRESS',
    ADDRESS_ASSOCIATION: 'Address must be associated with a profile',
    YOUR_JOIN_APPLICATION_HAS_BEEN_SENT: 'Your request to join is under review',
    SECRET: 'Secret',
    NETWORK_HEADING:'YPO Networks',
    NETWORK_RIGHT_HEADING:
    "Unlock the power of YPO by expanding your relationships with YPO members and spouses/partners, beyond your chapter, region and forum, who share your business interests and personal passions.",
    VISIT_NOW:'Visit Now',
    JOIN_THE_NETWORK: 'Join The Network',
    ABOUT_US: 'About Us',
    WAYS_TO_ENGAGE: 'Ways to Engage',
    SIGNATURE_EVENTS: 'Signature Events',
    RESOURCES: 'Resources',
    SEE_ALL: 'See All',
    MAX_NETWORK_CARDS_TO_SHOW: '4',
    LIVE_EVENT_CALENDAR:'live event calendar',
    VISIT_OUR:'Visit our',
    REGISTER_FOR_EVENTS:'to register for events.',
    DELETE_CONFIRMATION_MESSAGE: "Are you sure you want to delete?",
    MAX_LINK_LIMIT: 'Maximum number of links has been reached',
    WAYS_TO_ENGAGE_SMALL:'waysToEngage',
    RESOURCES_SMALL:'resources',
    EDIT:'edit',
    NEW_LINK:'newLink',
    SIGNATURE_EVENTS_SMALL:'signatureEvents',
    RELATED_CONTENT_SMALL:'relatedContent',
    RELATED_CONTENT_SECTION_NAME: 'relatedContentSectionName',
    ABOUT_US_SMALL: 'aboutUs',
    RELATED_CONTENT: 'Related Content',
    ADD_NETWORK_DESCRIPTION: 'Add Network Description',
    MAX_RANGE_FOR_WAYS_TO_ENGAGE: 8,
    MAX_RANGE_FOR_SIGNATURE_EVENTS: 4,
    MAX_RANGE_FOR_RESOURCES:8,
    MAX_RANGE_FOR_RELATED_CONTENT:15,
    ADD_NEW_LINK:'Add New Link',
    HOSPITALITY_BUSINESS_NETWORK_COMMUNITY_ID: '3c20969e-7d4f-de11-9c44-005056921c55',
    PHISHING_NOTIFICATIONS_GROUP: 'Phishing Notifications',
    CONTACT_CONCIERGE_DESK_TO_RESIGN: 'Please contact YPO Concierge Desk to resign from group',
    COMMUNITIES: 'Communities',
    YPO_COMMUNITIES: 'YPO Pilot Communities',
    COMMUNITIES_PILOT: 'Visit our Communities Pilot Hub page',
    COMMUNITIES_PILOT_LINK: 'https://www2.ypoconnect.org/topics/37504/page/home-79babcf8-e666-44ef-b78e-8c7a4e9fb4c2',
};
export const NoNetworkAffiliatedConstants = {
    Headings: {
        NOT_JOINED: 'You haven’t joined any Networks yet!',
    },
    Network_Type: {
        FAMILY: 'FAMILY NETWORKS',
        BUSINESS: 'BUSINESS NETWORKS',
        SOCIAL: 'SOCIAL IMPACT NETWORKS',
        PERSONAL: 'PERSONAL NETWORKS',
    },
    Description: {
        READ_ABOUT:
            'Read about the different Networks available or browse the list of YPO Networks to see a specific Network page.',
        BUSINESS:
            'Be a Better Leader and Run a More Successful Business<br>Business networks unite members in specific industries for targeted education and networking. They offer events such as annual multi-day roundtables with issues experts and offsite experiences, peer learning events, one-day member-led meetings that foster education about a particular topic and smaller events like meetings-in-meetings, which unite members in person at trade shows. Many offer network forums inviting members to discuss business-specific challenges with their peers in an environment of trust and confidentiality. Gain instant access to the cumulative experience of thousands of other leaders in your industry to be a better leader and run a more successful business.',
        PERSONAL:
            'Amplify Your Recreation in YPO Style<br>Personal networks enhance your enjoyment of life’s pleasures by introducing you to a welcoming community of other members and  spouses/partners who share similar passions. Benefit more from the time you spend doing what you love, garner access to experiences never before possible and find new friends with whom you can share those moments. Enjoy exclusive once-in-a-lifetime experiences that cannot be recreated anywhere else, and amplify your recreation in YPO style.',
        SOCIAL:
            'Make an Impact in Your Business, Community and Personal Journey<br>Social Impact Networks (SINC) are a valuable component of the YPO experience. Members, spouses/partners and YNGers explore ideas on how to do well while doing good in their sustainable businesses, within their communities and on a personal level. Join this vibrant community of other impact-oriented business and philanthropic leaders who share your vision to learn, lead and build a better world.',
        FAMILY:
            "Share, Learn and Grow in the Most Important Job You'll Ever Have.<br><br>Family Networks bring together members and spouses/partners to build personal relationships with other families from around the world, in a safe environment of confidentiality, trust and respect. Learn from well-respected experts, participate in informative global conference calls, attend inspirational webinars and engage in events for the entire family. Connect with fellow members and spouses/partners to support lifelong learning through experience, observation, discussion and reflection. Join us today, and help us shape tomorrow.",
    },
};

export const Administration = {
    NETWORK_ADMINISTRATION: 'Network Administration',
    REQUESTS: 'Requests',
    INVITE_SOMEONE: 'Invite Someone',
    YOUR_APPLICATION_SENT: 'Your application has been sent',
    ERROR_WHILE_SENDING_APPLICATION: 'Error While Sending Application',
    YOU_SUCCESSFULLY_JOINED: 'You have successfully joined',
    ERROR_WHILE_JOINING: 'Error While Joining',
    CLICK_HERE: 'Click here',
    MANAGE_NETWORK_NOTIFICATIONS: 'to manage your Network Notifications',
    EMAIL: 'Email',
    EMAIL_REQUEST: 'Email Request',
    DIRECT: 'Direct',
    MANAGE_PARTICIPANTS: 'Manage Participants',
    CONFIGURE_GROUP: 'Configure Group',
    NEW_GROUP_REQUESTS: 'New Group Requests',
    SUPER_ADMIN_OPTIONS: 'Super Admin Options',
    PENDING_ASSET_REQUEST: 'Pending Business Requests',
    YOUR_ARE_ALREADY_MEMBER: 'You are already a member of this community',
    REQUEST_SUBMITTED_PENDING: 'Thank you. Your request to join has been submitted for review',
};
export const getNetworkMenuModel = () => {
    return {
        communityId:'',
        id: null,
        value: '',
        url: null,
        displayOrder: '',
        categoryId: '',
        categoryName: null,
        isActive: false,
        fileName:'',
        imageURL:'',
        //isSSOEnabled: false,
    };
};

export const getNetworkContentModel = () => {
    return {
        communityId:'',
        id: null,
        value: '',
        url: null,
        displayOrder: '',
        categoryId: '',
        categoryName: null,
        isActive: false,
        fileName:'',
        imageURL:'',
        //isSSOEnabled: false,
    };
};

const resourceImagesNames = [
  { label: "Around Me", value: "AroundMe.svg" },
  { label: "Awards", value: "Awards.svg" },
  { label: "Brojure", value: "Brojure.svg" },
  { label: "ExCo", value: "ExCo.svg" },
  { label: "Facebook", value: "Facebook.svg" },
  { label: "Family Forum Toolkit", value: "FamilyForumToolkit.svg" },
  { label: "Forum", value: "Forum.svg" },
  { label: "In-Person Event", value: "InPersonEvent.svg" },
  { label: "Instagram", value: "Instagram.svg" },
  { label: "LinkedIn", value: "LinkedIn.svg" },
  { label: "Live Event", value: "LiveEvent.svg" },
  { label: "MicroForum", value: "MicroForum.svg" },
  { label: "News Letter", value: "NewsLetter.svg" },
  { label: "On-Demand", value: "OnDemand.svg" },
  { label: "Opportunity Hub", value: "OpportunityHub.svg" },
  { label: "Podcast", value: "Podcast.svg" },
  { label: "RoundTable", value: "RoundTable.svg" },
  { label: "Slack", value: "Slack.svg" },
  { label: "SocialMedia", value: "SocialMedia.svg" },
  { label: "Spotify", value: "Spotify.svg" },
  { label: "SubNetwork", value: "SubNetwork.svg" },
  { label: "Twitter", value: "Twitter.svg" },
  { label: "Video Series", value: "VideoSeries.svg" },
  { label: "WhatsApp", value: "WhatsApp.svg" },
  { label: "YNG City Groups", value: "YNGCityGroups.svg" },
  { label: "YNG Community Site", value: "YNGCommunitySite.svg" },
  { label: "YNG Connect Groups", value: "YNGConnectGroups.svg" },
  { label: "YouTube", value: "YouTube.svg" },
  { label: "Other", value: "Other.svg" },
];

export const getResourceImagesNames = () => {
    return orderBy(resourceImagesNames, 'value', "asc");
};

export const getResourceImagesLabel = (fileName)=> {
    const item = resourceImagesNames.find(r => r.value === fileName)
    return item ? item.label : 'Select Resource Type';
};
export const ypoNetworkMenuDialogFields = {
    DIALOG_TITLE: "Title",
    DIALOG_LINK: "Url/Email",
    DIALOG_IMAGE: "Resource Type",
    DIALOG_ALT_TEXT: "Alternative Text",
    DIALOG_BUTTON: "Title",
    DIALOG_LABEL: "Label", 
    DIALOG_SSO: "SSO Enabled",
    YES: "Yes",
    NO: "No",
    DIALOG_CATEGORY_LABEL: "Label",
    DIALOG_NEW_NETWORK_LABEL: "Add New Resource Type",
    DIALOG_NEW_LINK_LABEL: "Add New Link",
    CREATE_NEW_RELATED_CONTENT: "Add Network Content",
    CREATE_NEW_SIGNATURE_EVENT: "Create New Signature Event",
    ADD_PHOTO:'Add Photo',

};
export const ypoNetworkValidationRules = {
    CATEGORY_TITLE_RULE: [
      v => (!!v && !!v.trim()) || 'Please enter the title for category.',
    ],
    CATEGORY_LABEL_RULE: [
      v => (!!v && !!v.trim()) || 'Please enter the description.',
    ],
    BUTTON_TEXT_RULE: [
      v => (!!v && !!v.trim()) || 'Please enter the text for the button.',
    ],
    CATEGORY_NAVIGATION_RULE: [
      v => (!!v && !!v.trim()) || 'Please enter a valid url.',
    ],
    IMAGE_RULE: [
      v => (!!v && !!v.trim()) || 'Please enter a valid image.',
    ],
    CATEGORY_NAME_MAX_TEXT_LENGTH: 55,
    RESOURCE_LABEL_MAX_TEXT_LENGTH: 21,
    RELATED_CONTENT_TITLE_MAX_LENGTH: 60,
    HEADER_DESC_MAX_TEXT_LENGTH: 62,
    ABOUT_US_DESC_MAX_TEXT_LENGTH: 382,
    BUTTON_NAME_MAX_TEXT_LENGTH: 25,
    REQUIRED_RULE: [v => (!!v && !!v.trim()) || ''],
    NAVIGATION_URL_RULE: [
        v => {
          const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return (!!v && !!v.trim()) && (urlPattern.test(v) || emailPattern.test(v)) || 'Please enter a valid URL or email address.';
        }
      ],
    HEADER_NAVIGATION_URL_RULE: [
        v => {
            const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return (!v || v.trim() === '') || urlPattern.test(v) || emailPattern.test(v) || 'Please enter a valid URL or email address.';
        }
    ],
  };
  
export const networkLandingCategoryType = {
    IMAGE: "image",
    BUTTON: "button",
    CATEGORY: "category",
    LINK: "link",
    DESCRIPTION: "description",
    COMMUNITY_TAG_LINE: "communityTagLine",
    JOIN_NETWORK_BUTTON_TEXT: "joinNetworkButtonText"
};

export const resourceTypeHeaders = {
    relatedContent: ypoNetworkMenuDialogFields.CREATE_NEW_RELATED_CONTENT,
    signatureEvents: ypoNetworkMenuDialogFields.CREATE_NEW_SIGNATURE_EVENT,
    resources: ypoNetworkMenuDialogFields.DIALOG_NEW_NETWORK_LABEL,
    waysToEngage: ypoNetworkMenuDialogFields.DIALOG_NEW_LINK_LABEL,
  };
